import { render, staticRenderFns } from "./TeamCompetencySpread.vue?vue&type=template&id=5b896806&scoped=true"
import script from "./TeamCompetencySpread.vue?vue&type=script&lang=ts"
export * from "./TeamCompetencySpread.vue?vue&type=script&lang=ts"
import style0 from "./TeamCompetencySpread.vue?vue&type=style&index=0&id=5b896806&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b896806",
  null
  
)

export default component.exports